import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../openapi';

export type TaskNameType =
  'Zabudowy jednorodzinnej'
  | 'Zabudowy wielorodzinnej'
  | 'Obiektu handlowego'
  | 'Obiektu przemysłowego'
  | 'Inne'
  | string;

@Injectable()
export class LocalisationForm extends AppForm {

  public taskNameList: TaskNameType[] = [
    'Zabudowy jednorodzinnej',
    'Zabudowy wielorodzinnej',
    'Obiektu handlowego',
    'Obiektu przemysłowego',
    'Inne'
  ];

  constructor() {
    super({
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public get agreementNumber(): FormControl | null {
    return this.get('agreementNumber') as FormControl | null;
  }

  public get agreementDate(): FormControl | null {
    return this.get('agreementDate') as FormControl | null;
  }

  public createAgreementControls(): void {
    this.addControl('agreementNumber', new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(255)]
    }));
    this.addControl('agreementDate', new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] }));
  }

  public get surfaceType(): FormControl | null {
    return this.get('surfaceType') as FormControl | null;
  }

  public createSurfaceTypeControl(): void {
    this.addControl('surfaceType', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
  }

  public get city(): FormControl | null {
    return this.get('city') as FormControl | null;
  }

  public get street(): FormControl | null {
    return this.get('street') as FormControl | null;
  }

  public createStreetControl(required?: boolean): void {
    this.addControl('street', new FormControl('', {
      nonNullable: true,
      validators: required ? [Validators.required, Validators.maxLength(255)] : [Validators.maxLength(255)]
    }));
  }

  public get description(): FormControl | null {
    return this.get('description') as FormControl | null;
  }

  public createDescriptionControl(): void {
    this.addControl('description', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
  }

  public get taskName(): FormControl | null {
    return this.get('taskName') as FormControl | null;
  }

  public createTaskNameControl(): void {
    this.addControl('taskName', new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(255)]
    }));
  }

  public taskNameChange(v: TaskNameType): void {
    if (v === 'Inne') {
      this.createDescriptionControl();
    } else {
      this.removeControl('description');
    }
  }

  public get houseNumber(): FormControl | null {
    return this.get('houseNumber') as FormControl | null;
  }

  public createHouseNumberControl(required?: boolean): void {
    this.addControl('houseNumber', new FormControl(null, required ? [Validators.required, Validators.maxLength(255)] : [Validators.maxLength(255)]));
  }

  public createCityControl(): void {
    this.addControl(
      'city',
      new FormControl('Wałbrzych', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    );
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    return { ...value, description: this.description?.value || null };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchValue({
      ...value,
      city: 'Wałbrzych'
    });
    this.taskNameChange(value.taskName || '');
    this.description?.setValue(value.description);
  }

}
